<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Email</label>
            <crm-input-text
              [(value)]="profile.email"
              [disabled]="loadingProfile"
              [isError]="$any(profileError?.email)"
              (onBlur)="changeEmail(profile.email)"></crm-input-text>
            <small
              *ngIf="profileError?.email"
              class="p-error">
              {{ profileError?.email | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Имя</label>
            <crm-input-text
              [(value)]="profile.firstName"
              [disabled]="loadingProfile"
              [isError]="$any(profileError?.firstName)"></crm-input-text>
            <small
              *ngIf="profileError?.firstName"
              class="p-error">
              {{ profileError?.firstName | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Фамилия</label>
            <crm-input-text
              [(value)]="profile.lastName"
              [disabled]="loadingProfile"
              [isError]="$any(profileError?.lastName)"></crm-input-text>
            <small
              *ngIf="profileError?.lastName"
              class="p-error">
              {{ profileError?.lastName | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Отчество</label>
            <crm-input-text
              [(value)]="profile.middleName"
              [disabled]="loadingProfile"
              [isError]="$any(profileError?.middleName)"></crm-input-text>
            <small
              *ngIf="profileError?.middleName"
              class="p-error">
              {{ profileError?.middleName | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Телефон</label>
            <p-inputMask
              type="text"
              mask="+9 (999) 999-99-99"
              placeholder="+7 (999) 999-99-99"
              [unmask]="true"
              [(ngModel)]="profile.phone"
              [disabled]="loadingProfile"
              [ngClass]="{ 'ng-invalid ng-dirty': profileError?.phone }">
            </p-inputMask>
            <small
              *ngIf="profileError?.phone"
              class="p-error">
              {{ profileError?.phone | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Клиент</label>
            <crm-client-auto-complete
              [(selectedClient)]="user.client"
              [isError]="$any(errors?.client)"
              [customSearch]="false"
              [showClear]="true"
              appendTo="body"></crm-client-auto-complete>
            <small
              *ngIf="errors?.client"
              class="p-error">
              {{ errors.client | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Должность</label>
            <crm-input-text
              [(value)]="user.job"
              [isError]="$any(errors?.job)"></crm-input-text>
            <small
              *ngIf="errors?.job"
              class="p-error">
              {{ errors.job | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Контрагенты</label>
            <crm-contragent-multi-select
              [(selectedEntities)]="user.contragents"
              [clientIds]="[user.client?.id]"
              [isError]="$any(errors?.client)"
              appendTo="body"></crm-contragent-multi-select>
            <small
              *ngIf="errors?.contragents"
              class="p-error">
              {{ errors.contragents | join }}
            </small>
          </div>

          <div class="field-checkbox mb-0">
            <p-checkbox
              [(ngModel)]="user.isMailingEnabled"
              [binary]="true"
              inputId="isMailingEnabled"></p-checkbox>
            <label [for]="'isMailingEnabled'">Включить в рассылку</label>
          </div>

          <div
            *ngIf="isExternalUserActive(user)"
            class="mt-4">
            <p-messages severity="info">
              <ng-template pTemplate="">
                <div class="flex gap-2 align-items-center">
                  <i
                    class="pi pi-exclamation-circle"
                    style="font-size: 1.3rem"></i>
                  <p>
                    Разрешается создавать все заявки и управлять списком сотрудников Клиента {{ user.client?.name }}
                  </p>
                </div>
              </ng-template>
            </p-messages>

            <div class="field-checkbox mb-0">
              <p-checkbox
                [(ngModel)]="user.accessControl.admin"
                (ngModelChange)="onAdminAccessChange()"
                [binary]="true"
                inputId="isAccessControl"></p-checkbox>
              <label [for]="'isAccessControl'">Полный доступ в ЛК</label>
            </div>
          </div>
        </div>
      </p-card>

      <crm-external-user-permissions-widget
        *ngIf="user?.accessControl && !user.accessControl.admin"
        styleClass="mt-3"
        [user]="user"
        (accessChange)="updatePermissions($event)"></crm-external-user-permissions-widget>
    </div>
  </div>

  <div class="mt-3">
    <crm-button
      [label]="saveButtonLabel"
      styleClass="p-button-success"
      (onClick)="saveUser()"></crm-button>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
